import angular from 'angular';
import { transformODataResponse } from 'utilities/query';
import templateUrl from './information.html';

export default {
  templateUrl,
  bindings: {
    adverseEvent: '<',
    allowMultipleProducts: '<',
    symptoms: '<',
    locked: '<',
    memberId: '<'
  },
  controller: class AdverseEventInformationComponent {
    constructor($http, ToastService) {
      'ngInject';

      Object.assign(this, {
        $http,
        ToastService
      });

      this.today = new Date();
    }

    transformChip(chip) {
      if (angular.isObject(chip)) {
        return chip;
      }

      return { name: chip, type: 'new' };
    }

    searchSignedProductsByMember(searchText) {
      return this.$http.get('/odata/ProductOData', {
        params: {
          $select: 'ProductId, ProductName, DateIntroduced, Discontinued',
          $orderby: 'ProductName asc, DateIntroduced desc',
          $filter: `MemberId eq ${this.memberId} and SignDate ne null and contains(ProductName, '${searchText}')`
        }
      }).then(r => transformODataResponse(r).Data)
      .catch(error => this.ToastService.showError(error));
    }

    get maxProducts() {
      if (this.allowMultipleProducts) {
        return 100;
      }

      return 2;
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/adverse-event/information/information.component.js